import type { StaticApplicationsFooterBffFooterDto } from '@ori/static-api-client-react';
import { createContext } from 'react';

export interface FooterContext {
  data?: StaticApplicationsFooterBffFooterDto;
  isMobileOffice: boolean;
}

export const footerContext = createContext<FooterContext>({
  isMobileOffice: false,
});

export const FooterProvider = footerContext.Provider;
